import React, { useState } from 'react';

import styles from './ProductAvailability.module.css'
import { CollapseList } from "../../ui/DataDisplay/CollapseList/CollapseList.tsx";
import { Availability } from "../../types/ProductAvailability.interface.ts";
import { Icon } from "../../ui/General/Icon/Icon.tsx";

interface Props {
    availability: Availability[],
    updateBranch: (branchId: number) => void
    cardRef: React.RefObject<HTMLDivElement>,
}

/**
 * Блок "Доступно в других филиалах"
 * @param param
 * @returns 
 */
export const ProductAvailability: React.FC<Props> = ({ availability, updateBranch, cardRef }) => {
    const [showAll, setShowAll] = useState<boolean>(false);

    return availability.length > 0 &&
        <div className='mt-4'>
            <h4 className={styles.availabilityTitle} onClick={() => setShowAll(!showAll)}>
                Наличие в других филиалах
                <div className={styles.availabilityTitleIcon}><Icon name={!showAll ? 'triangle-up' : 'triangle-down'} width={15} height={7} color='#F39200' onClick={() => setShowAll(!showAll)} /></div>
            </h4>
            <div className='flex-1 sm:pl-8 flex flex-col justify-start'>
                <CollapseList showCount={showAll ? availability.length : 0} showButton={false} cardRef={cardRef}>
                    {availability.map(({ id, name }) =>
                        <div className='flex items-center justify-between py-2 border-b border-gray-200 last:border-b-0'>
                            <p className='w-1/2 text-base'>{name}</p>
                            <button className='inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 bg-[#F39200] hover:bg-orange-500 rounded-lg px-6 py-1 text-base font-bold text-white'
                                id={`select-availability-btn-${id}`}
                                onClick={() => updateBranch(id)}>
                                Выбрать
                            </button>
                        </div>
                    )}
                </CollapseList>
            </div>
        </div>;
};